import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FiscalYearReport = _resolveComponent("FiscalYearReport")!

  return (_openBlock(), _createBlock(_component_FiscalYearReport, {
    title: _ctx.title,
    filename: _ctx.filename,
    "is-searching": _ctx.isSearching,
    "report-data": _ctx.reportData,
    headers: _ctx.reportHeaders,
    "total-column-title": _ctx.totalColumnTitle,
    onSearch: _ctx.search
  }, null, 8, ["title", "filename", "is-searching", "report-data", "headers", "total-column-title", "onSearch"]))
}